const useTextTruncation = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;

  const words = text.split(" ");
  let truncated = "";

  for (const word of words) {
    if ((truncated + word).length + 1 > maxLength) break;
    truncated = truncated + (truncated ? " " : "") + word;
  }

  const shortenedText = truncated + " ...";
  return shortenedText;
};

export default useTextTruncation;
